 
<template>
    <div v-if="domain.includes('docuxtract.docunecta.com')" class='white_dns'>
        <v-card 
            color="#F2F1FF"
            elevation="0" 
            width="400" 
            class="mx-auto pa-5 rounded-xl card__signup__form" 
            :class="{'mt-5': $vuetify.breakpoint.smAndUp}"
        >
            <v-card-subtitle class="violet--text mt-2 mb-4">Disfruta de tu <strong><br>período de prueba gratuito</strong></v-card-subtitle>                                            
            <v-card-text class="pb-0"> 
                <v-form id="signup-form">
                    <v-text-field 
                        label="Usuario" 
                        prepend-inner-icon="mdi-account-circle" 
                        v-model="username"
                        solo
                        flat                                                    
                        color="#66369B"                                                   
                        background-color="#FFFFFF"
                        @keyup="usernameToLowerCase"
                    />
                    <v-text-field 
                        label="Email" 
                        prepend-inner-icon="mdi-email" 
                        v-model="email" 
                        solo
                        flat
                        color="#66369B"   
                        background-color="#FFFFFF"    
                        type="email" 
                        :error="error_email"                                                                                                                      
                    />
                    <v-text-field 
                        label="Repetir Email" 
                        prepend-inner-icon="mdi-email-check" 
                        v-model="email2" 
                        solo
                        flat
                        color="#66369B"   
                        background-color="#FFFFFF"    
                        type="email" 
                        :error="error_email2"
                        @paste.prevent
                        @click.right.prevent                                                                                                                      
                    />
                    <v-text-field
                        solo
                        flat
                        color="#66369B" 
                        background-color="#FFFFFF"
                        :type="showPassword ? 'text' : 'password'"
                        label="Contraseña"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        v-model="password"
                        @click:append="showPassword = !showPassword"
                        v-on:keyup.enter="signup"
                    />
                    <div class="d-flex justify-center">
                        <v-checkbox                                                    
                            v-model="privacyAccepted"                                                    
                            hide-details
                            class="mt-0 mb-3 checkbox__terms"
                            color="#66369B"
                        >
                            <template v-slot:label>
                                <div class="font-weight-light pl-1 pr-1">
                                He leído y acepto la
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                    <a
                                        target="_blank"
                                        rel="noopener"
                                        class="font-weight-light text-decoration-underline"                    
                                        href="https://inmatic.ai/legal/politica-de-privacidad/"
                                        v-bind="props"
                                        @click.stop
                                    >
                                        política de privacidad
                                    </a>
                                    </template>
                                    Abrir en nueva ventana
                                </v-tooltip>
                                </div>
                            </template>
                        </v-checkbox>
                    </div>
                    
                    <p v-if="error" class="red--text">{{error}}</p>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>                                            
                <v-btn 
                    rounded
                    elevation="0"
                    class="btn__signup font-weight-bold white--text mb-2 mx-auto px-6 py-6" 
                    color="#2DC4F7" 
                    :loading='loading' 
                    @click="signup"
                >
                    CREAR USUARIO
                </v-btn>
            </v-card-actions>
            <a class="d-block text-center" href="/login"><small>Si ya eres usuario haz clic aquí</small></a>
        </v-card>
    </div>
    <div v-else class="content-style">
        <app-header-public :transparentHeader="true" :hrefSignupOnPage="true"/>        
        <section id="main">
            <!-- Hero -->

            <v-card 
                tile
                class="elevation-0 d-flex align-center hero__signup"                    
                min-height="100vh"
                width="100vw"                
            >
                <v-container :fluid="$vuetify.breakpoint.mdAndUp" class="hero__container" :class="$vuetify.breakpoint.mdAndDown ? 'mb-0' : ''" >
                    
                        <v-row >
                            <v-col lg="1" v-if="$vuetify.breakpoint.xlOnly"></v-col>
                            <v-col lg="6" xl="5" sm="12" xs="12" md="6">
                                <v-row>
                                    <v-col v-if="$vuetify.breakpoint.lgAndUp" cols="2"></v-col>
                                    <v-col :cols="$vuetify.breakpoint.lgAndUp ? 9:12">
                                        <v-container :fluid="true" :class="{'pl-5':$vuetify.breakpoint.mdAndDown}">
                                            <div>
                                                <h1 :class="{'mt-5':$vuetify.breakpoint.mdAndUp,'text-center':$vuetify.breakpoint.smAndDown}" class="hero__title white--text mb-5">
                                                    <strong>CREA TU USUARIO</strong><br> Y EMPIEZA A SER MÁS PRODUCTIVO
                                                </h1>
                                                <p class="mb-5 white--text" :class="{'text-center':$vuetify.breakpoint.smAndDown}">Empieza la transformación de tu proceso contable a <b>golpe de clic</b>. Evita dedicar horas a <b>procesar facturas que se envían a última hora y que os cargan de trabajo</b>, especialmente en los cierres de trimestre.</p>
                                                <p class="mb-2 white--text" :class="{'text-center':$vuetify.breakpoint.smAndDown}">Olvídate de picar facturas. Empieza <b>a agilizar tus procesos</b> con el robot contable de Inmatic y consigue <b>mejorar la productividad de tu equipo</b>, además de <b>acelerar</b> esos interminables <b>cierres trimestrales</b>.</p>                                                
                                            </div>
                                        </v-container>
                                    </v-col>
                                    <v-col cols="1" v-if="$vuetify.breakpoint.lgAndUp" ></v-col>
                                </v-row>
                            </v-col>
                            <v-col lg="6" xl="5" sm="12" xs="12" md="6" class="pt-0">
                                <div :class="{'mt-6': $vuetify.breakpoint.smAndUp}">                                    
                                    <v-card 
                                        color="#F2F1FF"
                                        elevation="0" 
                                        width="400" 
                                        class="mx-auto pa-5 rounded-xl card__signup__form" 
                                        :class="{'mt-5': $vuetify.breakpoint.smAndUp}"
                                    >
                                        <v-card-subtitle class="violet--text mt-2 mb-4">Disfruta de tu <strong><br>período de prueba gratuito</strong></v-card-subtitle>                                            
                                        <v-card-text class="pb-0"> 
                                            <v-form id="signup-form">
                                                <v-text-field 
                                                    label="Usuario" 
                                                    prepend-inner-icon="mdi-account-circle" 
                                                    v-model="username"
                                                    solo
                                                    flat                                                    
                                                    color="#66369B"                                                   
                                                    background-color="#FFFFFF"
                                                    @keyup="usernameToLowerCase"
                                                />
                                                <v-text-field 
                                                    label="Email" 
                                                    prepend-inner-icon="mdi-email" 
                                                    v-model="email" 
                                                    solo
                                                    flat
                                                    color="#66369B"   
                                                    background-color="#FFFFFF"    
                                                    type="email" 
                                                    :error="error_email"                                                                                                                      
                                                />
                                                <v-text-field 
                                                    label="Repetir Email" 
                                                    prepend-inner-icon="mdi-email-check" 
                                                    v-model="email2" 
                                                    solo
                                                    flat
                                                    color="#66369B"   
                                                    background-color="#FFFFFF"    
                                                    type="email" 
                                                    :error="error_email2"
                                                    @paste.prevent
                                                    @click.right.prevent                                                                                                                      
                                                />
                                                <v-text-field
                                                    solo
                                                    flat
                                                    color="#66369B" 
                                                    background-color="#FFFFFF"
                                                    :type="showPassword ? 'text' : 'password'"
                                                    label="Contraseña"
                                                    prepend-inner-icon="mdi-lock"
                                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                    v-model="password"
                                                    @click:append="showPassword = !showPassword"
                                                    v-on:keyup.enter="signup"
                                                />
                                                <div class="d-flex justify-center">
                                                    <v-checkbox                                                    
                                                        v-model="privacyAccepted"                                                    
                                                        hide-details
                                                        class="mt-0 mb-3 checkbox__terms"
                                                        color="#66369B"
                                                    >
                                                        <template v-slot:label>
                                                            <div class="font-weight-light pl-1 pr-1">
                                                            He leído y acepto la
                                                            <v-tooltip location="bottom">
                                                                <template v-slot:activator="{ props }">
                                                                <a
                                                                    target="_blank"
                                                                    rel="noopener"
                                                                    class="font-weight-light text-decoration-underline"                    
                                                                    href="https://inmatic.ai/legal/politica-de-privacidad/"
                                                                    v-bind="props"
                                                                    @click.stop
                                                                >
                                                                    política de privacidad
                                                                </a>
                                                                </template>
                                                                Abrir en nueva ventana
                                                            </v-tooltip>
                                                            </div>
                                                        </template>
                                                    </v-checkbox>
                                                </div>
                                                
                                                <p v-if="error" class="red--text">{{error}}</p>
                                            </v-form>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <v-card-actions>                                            
                                            <v-btn 
                                                rounded
                                                elevation="0"
                                                class="btn__signup font-weight-bold white--text mb-2 mx-auto px-6 py-6" 
                                                color="#2DC4F7" 
                                                :loading='loading' 
                                                @click="signup"
                                            >
                                                CREAR USUARIO
                                            </v-btn>
                                        </v-card-actions>
                                        <a class="d-block text-center" href="/login"><small>Si ya eres usuario haz clic aquí</small></a>
                                    </v-card>
                                </div>
                            </v-col>
                            
                        </v-row>
                    </v-container> 
                
            </v-card>
            <!-- / Hero -->                
        </section>
        
        <app-footer-public/>
        
        
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import AppHeaderPublic from "@/components/layout/AppHeaderPublic";
import AppFooterPublic from "@/components/layout/AppFooterPublic";


export default {
    name: 'SignUpPage',
    components: {
        AppHeaderPublic,
        AppFooterPublic,    
    },
	data() {
		return {
			showPassword: false,
			username:'',
			password:'',
            email: '',
            email2: '',
			error: '',
			loading: false,            
            scrollPosition: null,
            isPopupVideoVisible:false,
            privacyAccepted:false,
            distributorCode: this.$route.params.distributor_code,
            domain: window.location.origin
        }
	},
    metaInfo() {
        return {
            title: this.pageTitle(),
            titleTemplate: null,
            meta: [
                {name: 'description', content: 'Crea tu usuario en Inmatic y empieza a ser más productivo. Contabiliza automáticamente tus facturas sin esfuerzo gracias a nuestra IA. ¡Pruébalo gratis!'},
                {name: 'robots', content: 'noindex'},
            ],
        }
    },
	computed: {
		...mapState([
			'currentCompany',
		]),
        error_email(){            
            if (this.email) {
                let re = /^[\w-\.]+@([\w-]+\.)+[\w]{2,3}$/        
                return !re.test(this.email);
            } else {        
                return false;
            }
        },
        error_email2(){            
            if (this.email2) {
                let re = /^[\w-\.]+@([\w-]+\.)+[\w]{2,3}$/        
                return !re.test(this.email2);
            } else {        
                return false;
            }
        },           
    },
    mounted(){
        if(this.domain.includes('docuxtract.docunecta.com')) {
            this.$router.push({name: 'signup',params: {'distributor_code': "docunecta"}})
        }
        this.changeCrispColor("light_blue");
        window.addEventListener('scroll', this.updateScroll);
    },
    beforeDestroy(){
      this.changeCrispColor("deep_purple");
    },
    methods: {
        ...mapActions({
            textToLowerCase: "config/textToLowerCase",
        }),       
        pageTitle() {
            if (window.location.origin.includes('docuxtract.docunecta.com')){
                return 'Crea tu usuario'
            } else {
                return 'Crea tu usuario - Inmatic'
            }
        },
        usernameToLowerCase() {
            this.textToLowerCase(this.username).then((res) => {
                this.username = res;
            }).catch(err => {
                console.error(err);
            });
        },
        isFormCorrect() {
            let isCorrect = true;
            let re = /^[\w-\.]+@([\w-]+\.)+[\w]{2,3}$/
            let username_re = /^[a-zA-Z0-9-_@.]+$/
            if (this.username.length <= 0) {
                isCorrect = false;
                this.error = 'No se ha introducido usuario';
            } else if (this.email.length <= 0) {
                isCorrect = false;
                this.error = 'No se ha introducido el email';
            } else if (!re.test(this.email)) {
                isCorrect = false;
                this.error = 'Email introducido no es valido';
            } else if (this.email != this.email2) {
                isCorrect = false;
                this.error = 'Los emails introducidos no son iguales';            
            } else if (this.password.length <= 0) {
                isCorrect = false;
                this.error = 'No se ha introducido la contraseña.'
            } else if (this.password.length < 8) {
                isCorrect = false;
                this.error = 'La contraseña debe tener un mínimo de 8 caracteres.' 
            } else if (this.username.includes(' ') || this.password.includes(' ')) {
                isCorrect = false;
                this.error = 'Ni el nombre de usuario, ni la contraseña pueden contener espacios.' 
            } else if (!username_re.test(this.username)) {
                isCorrect = false;
                this.error = 'Usuario invalido, no se permiten los caracteres introducidos';
            } else if (!this.privacyAccepted){
                isCorrect = false;
                this.error = 'Debe aceptar la política de privacidad.' 
            } 
            return isCorrect;
        },
        tooglePopupVideoVisibility(){
            return this.isPopupVideoVisible = !this.isPopupVideoVisible
        },
        async signup() {
            if (this.isFormCorrect()) {
                this.loading = true;
                try {
                    let payload = {
                        username: this.username,
                        email: this.email,
                        password: this.password,                        
                    }
                    if (this.distributorCode) {
                        payload.distributor_code = this.distributorCode;
                    }
                    const resp = await this.signUpUser(payload);
                    if (resp.data.signed) {
                        const result = await this.signInUser({
                            username: this.username,
                            password: this.password
                        });
                        this.loading = false;
                        this.setJWTToken(result);
                        this.setAfterLogged().then(() => {
                            this.$router.push(this.currentCompany.id + "/documents");
                        }).catch(err => { 
                            console.error(err);
                            this.$router.push("documents");
                        });
                    } else {
                        this.loading = false;
                        let err = resp.data['error'];
                        if (err.includes('UsernameExistsException')) {
                            this.error = 'Ya existe otro usuario con este nombre.'
                        } else if (err.includes('EmailExistsException')) {
                            this.error = 'Ya existe otro usuario con este email.'
                        } else {
                            this.error = 'No se ha podido crear el usuario.'
                        }
                    }
                } catch (error) {
                    this.loading = false;
                    this.error = error.message;
                }
            }
        },
        updateScroll() {
           this.scrollPosition = window.scrollY
        },        
        ...mapActions(["signUpUser", "signInUser", "setJWTToken", "setAfterLogged","changeCrispColor"]), 
    }
}
</script>

<style scoped>   
    .content-style {
        /* background: -webkit-gradient(linear, left top, right top, from(#33ccff), color-stop(30%, #663399)) !important; */
        /* background: linear-gradient(to right, #33ccff 0%, #663399 30%) !important; */
        height: 100%;
        margin-top:-140px;
    }
    .hero__signup {
        background-image: url('/inmatic_bg_nohand.jpg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        position:relative;
    }

    .hero__signup .hero__container {
        padding-top: 100px;
        padding-bottom:160px;
    }   

    .hero__signup .hero__title {
        font-size: 3rem;        
        font-family: "Kanit",sans-serif;
        line-height: 60px;
        font-weight: 400;
    }
    .hero__signup .hero__title .hero__title-bold {
        font-weight: bold;
    }
    .hero__signup .hero__text {
        font-size:20px;
        font-family: "Roboto", sans-serif !important;
    } 
        
    .card__signup__form .v-card__subtitle {
        font-size:22px;
        text-align: center;
    }
    .violet--text {
        color:#66369B !important;
    }
    #signup-form {
        scroll-margin-top: 220px;
    }
    >>>.checkbox__terms .v-label{
        font-size:14px !important;
    }
    .new__primary {
        color: #050D4C !important;
    }
    
    @media screen and (max-width: 600px) {   
        .hero__signup .hero__container {
            padding-top: 140px;
        }
        .hero__signup .hero__title {
            font-size: 1.7rem;
            line-height: 28px;
        }  
        .hero__signup .hero__text {
            font-size:16px;
        }             
        .card__signup__form .v-card__subtitle {
            font-size:18px;
        }
    }
    @media screen and (min-width: 600px) {
        .hero__signup .hero__container {
            padding-top: 140px;        
        }
    }
    @media screen and (min-width: 600px) and (max-width: 960px) {
        .hero__signup .hero__title {
            font-size: 1.9rem;
            line-height: 35px;
        }        
    }
    @media screen and (min-width: 960px) and (max-width: 1264px) {
        .hero__signup .hero__title {
            font-size: 2.5rem;
            line-height: 45px;
        }
    }
    .v-application p {
        font-family: "Roboto",sans-serif !important;
    }
    .v-application {
        font-family: "Roboto",sans-serif; 
        line-height: 1.5;
    }
    .v-application .text-body-1 {
        font-size: 1rem!important;
        font-weight: 400;
        line-height: 1.5rem;
        letter-spacing: .03125em!important;
        font-family: "Roboto",sans-serif!important;
    }    
    .dcontainer {
        width:80%;
    }
    hr {
        border-color: transparent !important;
    }
    .v-btn{
        text-transform:none;
    }
    .v-btn.btn__signup {
        width: 100%;
        max-width: 280px;
    }
    .wrapper{
        position: relative;
    }
    .white_dns {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
